import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "./components/ui/provider";
import { CssBaseline, ThemeProvider } from "@mui/material";
import "./index.css";
import App from "./App.tsx";
import client from "./graphql/client.ts";
import { ApolloProvider } from "@apollo/client";
import { appTheme } from "./theme/muiTheme";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Provider>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </Provider>
    </ThemeProvider>
  </StrictMode>
);
